var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6058 37.1711C18.698 37.1711 15.7905 37.1711 12.883 37.1711C10.6048 37.1711 8.85143 35.2607 9.13324 33.0096C9.23634 32.1891 9.49491 31.38 9.75307 30.589C10.4937 28.3197 11.6307 26.2676 13.2413 24.4904C14.1224 23.5117 15.146 22.6708 16.2779 21.996C16.4528 21.8923 16.5737 21.883 16.7621 21.9981C20.0171 23.9694 23.2692 23.9596 26.5183 21.9686C26.6603 21.8818 26.7528 21.8805 26.8926 21.9623C28.7939 23.0775 30.2913 24.6068 31.4904 26.438C32.7431 28.3509 33.5704 30.4435 34.0542 32.6706C34.5189 34.8079 32.9958 36.9017 30.8127 37.1399C30.6029 37.162 30.392 37.1727 30.181 37.172C27.3229 37.1728 24.4645 37.1726 21.6058 37.1711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5981 22.2558C17.3891 22.2684 13.8937 18.8118 13.8848 14.6279C13.8751 10.3192 17.2987 6.83736 21.5559 6.82766C25.8287 6.81628 29.3335 10.2471 29.3436 14.4508C29.3542 18.8042 25.9449 22.2406 21.5981 22.2558Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f9f0ab087505b2561b7fdfc59cb77f73.svg";
export { ForwardRef as ReactComponent };